import { useEffect } from "react";

// Lightweight SEO helper: sets document title + meta description per page.
export default function Seo({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} | Video Game Mania`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
